import { Features } from 'mk2/apps/strollers/schemas';
import { niceNumber } from 'mk2/apps/strollers/utils';
import React from 'react';
import styles from './NumericOptionalRangeFeature.mscss';

interface OwnProps {
    features: Features;
    feature: any;
}

const hasVal = (value) => {
    return (value !== undefined) && (value !== null);
};

const renderValue = (value) => {
    return hasVal(value) ? niceNumber(value) : '?';
};

const renderRange = (minValue, maxValue) => {
    if (minValue === maxValue) {
        return renderValue(minValue);
    }
    if (hasVal(minValue) || hasVal(maxValue)) {
        return `${renderValue(minValue)}\u00A0\u2013\u00A0${renderValue(maxValue)}`;   // beware: nbsp + ndash used
    }
    const value = maxValue || minValue;
    return renderValue(value);
};

export class NumericOptionalRangeFeature extends React.Component<OwnProps> {
    public render() {
        const { feature, features } = this.props;

        if (!feature.hasWorthyValue(features)) {
            return null;
        }

        const valueMax = features[feature.featureName + '_max'];
        const valueMin = features[feature.featureName + '_min'];

        return (
            <div className={styles.NumericOptionalRangeFeature}>
                {renderRange(valueMin, valueMax)}
            </div>
        );
    }
}
